/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_Too_Many_FilesInputs */

const nl_tickets_too_many_files = /** @type {(inputs: Tickets_Too_Many_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt maximaal 5 bestanden toevoegen.`)
};

/**

* @param {Tickets_Too_Many_FilesInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_too_many_files = /** @type {((inputs?: Tickets_Too_Many_FilesInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_Too_Many_FilesInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_too_many_files(inputs)
});
export { tickets_too_many_files as "tickets.too_many_files" }